import { computed, ref } from 'vue'

import type { Ref, WritableComputedRef } from 'vue'
import type { TasksKanbanLogsFilterParams } from './interfaces'

import { useFilterDateRange, useFilterSearch } from '@shared/lib/filters'
import { useRefreshQuery } from '@shared/lib/routes'

import { buildLogQueryObject, parseLogFilterParams } from './filters/parse-log-filter-params'

interface TasksKanbanLogFiltersReturn {
  filterResetKey: Ref<number>
  searchQuery: Ref<string>
  dateRange: WritableComputedRef<Date[] | null>
  handleSearch: () => void
  handleClear: () => void
}

export const useTasksKanbanLogFilters = (): TasksKanbanLogFiltersReturn => {
  const route = useRoute()
  const { refreshQuery } = useRefreshQuery()

  const filterResetKey = ref(0)

  const initialParams = parseLogFilterParams(route.query)

  const {
    query: searchQuery,
  } = useFilterSearch({ initial: initialParams.query })

  const {
    range: dateRange,
    from: dateFrom,
    to: dateTo,
  } = useFilterDateRange({
    initialFrom: initialParams.date_from,
    initialTo: initialParams.date_to,
  })

  const queryParams = computed<TasksKanbanLogsFilterParams>(() => ({
    query: searchQuery.value || null,
    date_from: dateFrom.value,
    date_to: dateTo.value,
  }))

  const handleSearch = (): void => {
    const query = buildLogQueryObject(queryParams.value)
    void refreshQuery(query)
  }

  const handleClear = (): void => {
    searchQuery.value = ''
    dateRange.value = null
    filterResetKey.value++

    void refreshQuery({})
  }

  return {
    filterResetKey,
    searchQuery,
    dateRange,
    handleSearch,
    handleClear,
  }
}